import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { WorksheetRootComponent } from 'Components/Worksheets/Core';
import { useSelector } from 'react-redux';
import ids from '../../QestIds';
import AsRelativeCompactionFieldWorksheet from './Worksheets/AsRelativeCompactionFieldWorksheet';
import AsRelativeCompactionLabWorksheet from './Worksheets/AsRelativeCompactionLabWorksheet';

let Worksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const QestFieldUserAgent = useSelector(() => window.qest.userAgent?.includes('[QFW]'));

  //If the user agent is being accessed via QESTField, We want to render only the `Field` component (Related Test Data only)
  //Otherwise we render the full test
  return QestFieldUserAgent ? <AsRelativeCompactionFieldWorksheet /> : <AsRelativeCompactionLabWorksheet />;
};

Worksheet.qestIds = [ids.relativeCompaction.AS_1289_5_4_1.rev2007];
const AsRelativeCompactionWorksheet = withInjectedProps(Worksheet);

export { AsRelativeCompactionWorksheet };
export default AsRelativeCompactionWorksheet;
